/*
import { useAppStore } from '~/stores/AppStore'
import { AppTheme, DarkSide, DARK_ROUTES } from '~/types'

export default defineNuxtRouteMiddleware((to) => {
  const store = useAppStore()

  if (DARK_ROUTES.includes(to.path as DarkSide) || to.path.startsWith(DarkSide.NEWS)) {
    store.setTheme(AppTheme.DARK)
  } else {
    store.setTheme(AppTheme.LIGHT)
  }
})
*/
export default defineNuxtRouteMiddleware(() => {})
